import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Apartment, Assignment, Description, Groups, Home, Spa, WorkspacePremium } from '@mui/icons-material';
import { List } from '@mui/material';
import MenuItem from 'components/shared/menus/MenuItem';
import routes from 'common/routes';
import SidebarPanelContext from 'context/SidebarPanelContext';

/**
 * Menú del panel "Prometeo" (empresa cliente). Reemplaza por completo al menú de
 * cliente: quien administra la empresa no ve agenda, rutinas ni pagos personales, solo el
 * tablero de su organización. Todo es informativo o de descarga.
 */
function OrgClientDesktopMenu() {
  const { t } = useTranslation(['orgClient']);

  // Rail colapsado: lo decide el panel host (desktop mini / mobile expandido).
  const { iconOnly: miniDrawer } = useContext(SidebarPanelContext);

  return (
    <List>
      <MenuItem
        exact
        icon={<Home />}
        iconOnly={miniDrawer}
        itemKey="org-home"
        label={t('menu.home', { defaultValue: 'Inicio' })}
        path={routes.orgClientDashboard.path}
      />
      <MenuItem
        icon={<Spa />}
        iconOnly={miniDrawer}
        itemKey="org-wellbeing"
        label={t('menu.wellbeing', { defaultValue: 'Bienestar' })}
        path={routes.orgClientWellbeing.path}
      />
      <MenuItem
        icon={<Apartment />}
        iconOnly={miniDrawer}
        itemKey="org-departments"
        label={t('menu.departments', { defaultValue: 'Departamentos' })}
        path={routes.orgClientDepartments.path}
      />
      <MenuItem
        icon={<Groups />}
        iconOnly={miniDrawer}
        itemKey="org-members"
        label={t('menu.members', { defaultValue: 'Colaboradores' })}
        path={routes.orgClientMembers.path}
      />
      <MenuItem
        icon={<Description />}
        iconOnly={miniDrawer}
        itemKey="org-reports"
        label={t('menu.reports', { defaultValue: 'Reportes' })}
        path={routes.orgClientReports.path}
      />
      <MenuItem
        icon={<WorkspacePremium />}
        iconOnly={miniDrawer}
        itemKey="org-plans"
        label={t('menu.plans', { defaultValue: 'Planes' })}
        path={routes.orgClientPlans.path}
      />
      <MenuItem
        icon={<Assignment />}
        iconOnly={miniDrawer}
        itemKey="org-legal"
        label={t('menu.legal', { defaultValue: 'Términos y condiciones' })}
        path={routes.viewTC.path}
      />
    </List>
  );
}

export default OrgClientDesktopMenu;
